import { render, staticRenderFns } from "./TesseractIconWhite.vue?vue&type=template&id=460994fa&"
import script from "./TesseractIconWhite.vue?vue&type=script&lang=js&"
export * from "./TesseractIconWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports